/**
 * Canonical client comparison key — mirror of backend canonicalClientKey /
 * expectedDiscrepancyKey (src/config/client-aliases.ts): single-hop alias resolution,
 * case-insensitive.
 */
export function canonicalClientKey(name: string, aliases: Record<string, string>): string {
  const lower = name.trim().toLowerCase();
  for (const [key, value] of Object.entries(aliases)) {
    if (key.toLowerCase() === lower) return value.trim().toLowerCase();
  }
  return lower;
}

export function expectedGapKey(
  entry: { clientName: string; type: string },
  aliases: Record<string, string>
): string {
  return `${canonicalClientKey(entry.clientName, aliases)}|${entry.type}`;
}

/**
 * Index an audit run's per-entry match counts by canonical key. Duplicate entries for
 * one gap keep the highest count — a later duplicate must never overwrite a real
 * count with 0 (that showed LUDI as "Stale" while it suppressed 15 devices).
 */
export function indexMatchCounts(
  entries: Array<{ clientName: string; type: string; matchCount: number }>,
  aliases: Record<string, string>
): Map<string, number> {
  const counts = new Map<string, number>();
  for (const entry of entries) {
    const key = expectedGapKey(entry, aliases);
    counts.set(key, Math.max(counts.get(key) ?? 0, entry.matchCount));
  }
  return counts;
}
